export default __webpack_public_path__ + "img/pin_icons/medgas_panel_w.png";